// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  beforeHeading: "SectionProse__beforeHeading",
  closing: "SectionProse__closing",
  content: "SectionProse__content",
  flushBottom: "SectionProse__flushBottom",
  flushTop: "SectionProse__flushTop",
  opening: "SectionProse__opening",
  pull: "SectionProse__pull",
  section: "SectionProse__section",
};
